/**
* @param modalsCms: Cms translation for modals
* @param socialList: Array of types of social applications to share in the list
* @param shareUrl: Url to share (required in copy URL)
* @param location: the page this component get added
* @param entityType: edit url in member or team page
* @param viewState: view state of user (private or public)
* @param onSelect: trigger onSelect function in parent component
* @param getSocialContext: get social share data
*/
import React from 'react';
import { Title, UrlContainer, UrlContent, UrlDisplay, UrlEdit, EditIcon, EditInput, EditContent, CharacterLeft, Actions, Error, EditButtons, EditButton, ButtonContainer, SocialListContainer, Button, SocialIcon, FooterButton } from "./ShareSocials.style";
import helper from 'components/utils/helper';

const ShareSocials = ({modalsCms, socialList, shareUrl, location, entityType, viewState, onSelect, getSocialContext }) => {
    const [ editingUrl, setEditingUrl ] = React.useState(false);
    const [ urlPostfix, setUrlPostfix ] = React.useState(shareUrl.substring(shareUrl.lastIndexOf('/')+1) || '');
    const [ initUrlPostfix, setInitUrlPostfix ] = React.useState(urlPostfix);
    const maxUrlPostfixLength = 32;
    const [ char, setChar] = React.useState(Math.max(0, maxUrlPostfixLength - urlPostfix.length));
    const [ showError, setShowError ] = React.useState(false);

    const defaultSocialList = [
        {
            type: "copyUrl",
            iconClass: "fas fa-clone",
            translation: modalsCms.share.options.url
        },
        {
            type: "whatsapp",
            iconClass: "fab fa-whatsapp",
            translation: modalsCms.share.options.whatsapp
        },
        {
            type: "facebook",
            iconClass: "fab fa-facebook-f",
            translation: modalsCms.share.options.facebook
        },
        {
            type: "twitter",
            iconClass: "fab fa-twitter",
            translation: modalsCms.share.options.twitter
        },
        {
            type: "linkedin",
            iconClass: "fab fa-linkedin-in",
            translation: modalsCms.share.options.linkedin
        },
        {
            type: "mail",
            iconClass: "fas fa-envelope",
            translation: modalsCms.share.options.email
        },
    ].filter(a=>a);

    let optionList = socialList ? defaultSocialList.filter(i => socialList.includes(i.type)) : defaultSocialList;
    const shareModal = socialNetwork => {
        const { title, desc, url } = getSocialContext(socialNetwork);
        helper.shareModal(socialNetwork, url, desc, title);
    }
    
    function copyToClipBoard() {
        let stringToCopy;
        if (getSocialContext && !(entityType === 'team' || entityType === 'member')) {
            stringToCopy = getSocialContext('copyUrl').url;
        } else {
            stringToCopy = shareUrl.substring(0, shareUrl.lastIndexOf('/')+1) + urlPostfix +  "?" + "mc=1";
        }
        helper.copyToClipBoard(stringToCopy);
    }

    function getDataAnalyticAttributes(shareType) {
        switch (location){
            case "mospace":
                return {
                    "data-dl-category": "mo space",
                    "data-dl-location": "hero area",
                    "data-dl-label": "Share Mospace On " + shareType
                };
            case "events":
                return {
                    "data-dl-category": "events",
                    "data-dl-location": "hero area",
                    "data-dl-label": "Share Event On " + shareType
                };
            case "donate":
                return {
                    "data-dl-category": "donate",
                    "data-dl-location": "thank you",
                    "data-dl-label": "Share Donation On " + shareType
                };
            case "story":
                return {
                    "data-dl-category": "content",
                    "data-dl-location": "stories",
                    "data-dl-label": "Share Story On " + shareType
                };
            default:
                return null;
        }
    }

    function onChangeUrl(e){
        let value = e.target.value;
        let urlPostfixLength = value.length;
        if(urlPostfixLength <= maxUrlPostfixLength){
            setChar(Math.max(0, maxUrlPostfixLength - urlPostfixLength));
            setUrlPostfix(value);
            setShowError(false);
        }
      
    }

    function onClickSave(){
        // mov.helper.overlay.showGlobalLoading();
        // if(entityType === 'team'){
        //     mov.service.team.setTeamUrlShortcut(urlPostfix, {
        //         done: () => {
        //             mov.helper.overlay.hideGlobalLoading();
        //             setEditingUrl(false);
        //             mov.helper.broadcast.trigger('mospace-team-url-updated', {entityType: 'team', entityId: mov.service.team.getId()});
        //         },
        //         fail: () => {
        //             setShowError(true);
        //             mov.helper.overlay.hideGlobalLoading();
        //         }
        //     });
        // } else {
        //     mov.helper.api.get('availability', { member_id: mov.service.member.getId(), url: urlPostfix}, (response) => {
        //         if(response.status){
        //             $.postJSON( mov.vars.baseUrl + 'mospace/edit-details/save-personal-url', { personalurl: urlPostfix }, (response) => {
        //                 if( response.result ){
        //                     setEditingUrl(false);
        //                     // Reload mospace heroarea
        //                     mov.helper.broadcast.trigger('mospace-member-personalurl-updated', {entityType: 'member', entityId: mov.service.member.getId()});
        //                 } else {
        //                   setShowError(true);
        //                 }
        //                 mov.helper.overlay.hideGlobalLoading();
        //             });
        //         } else {
        //             setShowError(true);
        //             mov.helper.overlay.hideGlobalLoading();
        //         }
        //     });
        // }
    }

    function onClickCancel(){
        setUrlPostfix(initUrlPostfix);
        setChar(Math.max(0, maxUrlPostfixLength - initUrlPostfix.length));
        setEditingUrl(false);
        setShowError(false);
    }


    function getDynamicStyle(which){
        const hide = { style:{display:"none"}},
        error = { style:{border: 'solid 1px #FF0000',  backgroundColor: 'rgba(0, 0, 0, 0.1)'}};
        switch(which){
            case 'display':
                return editingUrl ? hide : null;
            case 'edit':
                return !editingUrl ? hide : null;
            case 'icon':
                return (viewState === 'private' && (entityType === 'team' || entityType === 'member')) ? null : hide;
            case 'error':
                return !showError ? hide : null;
            case 'input':
                return showError ? error : null;
        }
    }

    function onClickSocial(type){
        switch (type) {
            case "copyUrl":
                copyToClipBoard();
                break;
            case "whatsapp":
                shareModal('whatsapp');
                break;
            case "facebook":
                shareModal('facebook');
                break;
            case "twitter":
                shareModal('twitter');
                break;
            case "linkedin":
                shareModal('linkedin');
                break;
            case "mail":
                shareModal('email');
                break;
        }
        onSelect();
    }

    return ( 
        <SocialListContainer>
            <Title>{modalsCms.share.titleStory}</Title>
            <UrlContainer>
                <UrlDisplay {...getDynamicStyle('display')}>
                    <UrlContent>{shareUrl.substring(0, shareUrl.lastIndexOf('/')+1) + urlPostfix}</UrlContent>
                    <EditIcon onClick={() => setEditingUrl(true)}
                        {...getDynamicStyle('icon')}
                        alt-text="Edit Profile URL"
                        data-dl-category="mo space"
                        data-dl-location="hero area"
                        data-dl-label="edit profile url"
                        data-test="share-url-editLink">
                        <img src="/assets/images/icons/pen.png"/>
                    </EditIcon>
                </UrlDisplay>
                <UrlEdit {...getDynamicStyle('edit')}>
                    <EditContent>
                        <UrlContent>{shareUrl.substring(0, shareUrl.lastIndexOf('/')+1)}</UrlContent>
                        <EditInput value={urlPostfix} onChange={onChangeUrl} {...getDynamicStyle('input')}/>
                    </EditContent>
                    <Actions>
                        <CharacterLeft>
                        {char}{" "}{"text-mospace-member-title-character-left"}
                        </CharacterLeft>
                        <Error {...getDynamicStyle('error')}
                        dangerouslySetInnerHTML={{__html:"text-error-member-personalurl-notvalid"}}/>
                        <EditButtons>
                            <EditButton isPrimary={true} onClick={onClickSave} {...(initUrlPostfix === urlPostfix) && {disabled:true}}>
                            {"text-mospace-member-title-save"}
                            </EditButton>
                            <EditButton onClick={onClickCancel}>
                            {"text-mospace-member-title-cancel"}
                            </EditButton>
                        </EditButtons>
                    </Actions>
                </UrlEdit>
            </UrlContainer>
            { 
                optionList.map((social, index) => (
                    <ButtonContainer key={index}>
                        <Button {...getDataAnalyticAttributes(social.type)}
                                onClick={() => onClickSocial(social.type)}
                                marginTop={(index===0) ? "8px": null} marginBottom={(index===0) ? "16px": null}>
                            <SocialIcon className={social.iconClass}></SocialIcon>
                            {social.translation}
                        </Button>
                    </ButtonContainer>
                ))
            }
        </SocialListContainer>
    );
}
 
export default ShareSocials;
